/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Meta_TitleInputs */

const es_settings_meta_title = /** @type {(inputs: Settings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata | Configuración`)
};

const en_settings_meta_title = /** @type {(inputs: Settings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata | Settings`)
};

/**
* | output |
* | --- |
* | "Nexata \| Settings" |
*
* @param {Settings_Meta_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_meta_title = /** @type {((inputs?: Settings_Meta_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Meta_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_meta_title(inputs)
	return en_settings_meta_title(inputs)
});
export { settings_meta_title as "settings.meta.title" }